var forms = document.querySelectorAll('.site-header__search-form');

(function() {
    var name="nostojs";
    window[name]=window[name]||function(cb){(window[name].q=window[name].q||[]).push(cb);};
   })();

function addEventListenersToForms() {
    forms.forEach(function (form) {
        var input = form.querySelector('.site-header__search-input');

        if (input) {
            input.addEventListener('focus', function () {
                form.classList.add('focused');
            });

            input.addEventListener('blur', function () {
                form.classList.remove('focused');
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    addEventListenersToForms();
    initializeProductsSlider();
    // Call the function to initialize the event handler
    initializeCartRemoveHandler();
});

document.addEventListener('recommendations:loaded', () => {
    initializeProductsSlider();
});

document.addEventListener('recentlyViewed:loaded', () => {
    document.querySelector('.js-grid-slider').classList.add('grid-slider')

    initializeProductsSlider();
});

function initializeProductsSlider(  ) {
    const grids = document.querySelectorAll('.grid-slider:not(.enable-slider)');
    if (grids.length > 0) {
        grids.forEach(grid => {
            new Flickity(grid, {
                cellAlign: 'left',
                contain: true,
                autoPlay: false,
                // wrapAround: true,
                prevNextButtons: false,
                pageDots: false
            });
            grid.classList.add('enable-slider');
        });
    }
}

function initializeCartRemoveHandler() {
    document.addEventListener('click', function (e) {
        if (e.target.closest('.js-cart-item__remove .text-link')) {
            e.preventDefault();
            var cartItemSub = e.target.closest('.cart__item-sub');
            cartItemSub.querySelector('.js-qty__num').value = 0;
            cartItemSub.querySelector('.js-qty__adjust--minus').click();
        }
    });
}

function initDynamicProducttitle (){
  let isFunctionCalled = false;
  let deskContentEmpty = true;
  let mobileContentEmpty = true;
  let desktopParrentTrigger = document.querySelector("[desktop-trigger]");
  let mobileParrentTrigger = document.querySelector("[mobile-trigger]");

  if(window.innerWidth < 768){
    mobileParrentTrigger.innerHTML = desktopParrentTrigger.innerHTML;
    desktopParrentTrigger.innerHTML = "";
    
    mobileContentEmpty = false;
  }else{
    deskContentEmpty = false;
  }

  window.addEventListener('resize', () => {
    if(window.innerWidth < 768 && !isFunctionCalled && mobileContentEmpty){
      mobileParrentTrigger.innerHTML = desktopParrentTrigger.innerHTML;
      desktopParrentTrigger.innerHTML = "";

      isFunctionCalled = true;
      mobileContentEmpty = false;
      deskContentEmpty = true;
    }else if (window.innerWidth >= 768 && !isFunctionCalled && deskContentEmpty) {
      desktopParrentTrigger.innerHTML = mobileParrentTrigger.innerHTML;
      mobileParrentTrigger.innerHTML = "";
      
      isFunctionCalled = true;
      deskContentEmpty = false;
      mobileContentEmpty = true;
    } else if (window.innerWidth >= 768) {
      isFunctionCalled = false;
    }
  })
}

function updateSelleasyTitles (){
  window.addEventListener('lb-upsell-widget-event', function(event) {
    if(event.detail && event.detail.status === 'initialized'){

      if(document.querySelector('lb-upsell-product-page-addon')){
        let parrent = document.querySelector('lb-upsell-product-page-addon');
        let productsTitle = parrent.querySelectorAll('.lb-spc-details-name');
        let title = parrent.querySelector('.lb-upsell-ppa-title');
        let desc = parrent.querySelector('.lb-upsell-ppa-offer-desc');
  
        
        let customTitle = document.createElement('div');
        let customDesc = document.createElement('div');

        if(productsTitle.length > 0){
          for(let i = 0; i < productsTitle.length; i++){
            let customProductTitle = document.createElement('h3');
            customProductTitle.innerText = productsTitle[i].innerText;
            productsTitle[i].innerText = ''; 
            productsTitle[i].append(customProductTitle);;
            customProductTitle.style.marginBottom = '0px';
            customProductTitle.style.fontSize = 'inherit';
          }
        }
  
        if(title){
          customTitle.classList.add('lb-upsell-ppa-title')
          customTitle.innerHTML = title.innerHTML;
          title.replaceWith(customTitle);
        }
  
        if(desc){
          customDesc.classList.add('lb-upsell-ppa-offer-desc')
          customDesc.innerHTML = desc.innerHTML;
          desc.replaceWith(customDesc);
        }
      }

      if(document.querySelector('lb-product-page-cross-sell-ew')){
        let parrent = document.querySelector('lb-product-page-cross-sell-ew');
        let productsTitle = parrent.querySelectorAll('.lb-spc-details-name');
        let title = parrent.querySelector('.ppcse-title');
        let desc = parrent.querySelector('.ppcse-offer-desc');
        
        let customTitle = document.createElement('div');
        let customDesc = document.createElement('div');

        if(productsTitle.length > 0){
          for(let i = 0; i < productsTitle.length; i++){
            let customProductTitle = document.createElement('h3');
            customProductTitle.innerText = productsTitle[i].innerText;
            productsTitle[i].innerText = ''; 
            productsTitle[i].append(customProductTitle);;
            customProductTitle.style.marginBottom = '0px';
            customProductTitle.style.fontSize = 'inherit';
          }
        }
  
        if(title){
          customTitle.classList.add('ppcse-title')
          customTitle.innerHTML = title.innerHTML;
          title.replaceWith(customTitle);
        }
  
        if(desc){
          customDesc.classList.add('ppcse-offer-desc')
          customDesc.innerHTML = desc.innerHTML;
          desc.replaceWith(customDesc);
        }
      }
    }
  }, false);
}

if(document.querySelector('[data-section-type="product"]')){
  initDynamicProducttitle();
  updateSelleasyTitles();
}


let couponTextEl = document.querySelector('.js-coupon-text');
let couponCopyInfoEl = document.querySelector('.coupon-copy-info');

if(couponTextEl && couponCopyInfoEl){
  couponTextEl.addEventListener('dblclick',  (event) => copyToClipboard(event))
  couponTextEl.addEventListener('touchend',  (event) => copyToClipboard(event))
};

function copyToClipboard(event) {
  const target = event.target;
  let copied = target.getAttribute('data-copied');
  const couponText = target.getAttribute('data-coupon');

  if (copied == 'false') {
    const tempInput = document.createElement('textarea');
    couponCopyInfoEl.classList.add('show');

    tempInput.value = couponText;
    document.body.appendChild(tempInput);

    tempInput.select();
    document.execCommand('copy');

    target.setAttribute('data-copied', true);
    target.setAttribute('title', 'Promo code copied to clipboard...');

    document.body.removeChild(tempInput);

    setTimeout(() => {
      couponCopyInfoEl.classList.remove('show');
    }, 4000);
  }
}